import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { Grid, TextField, Typography } from '@mui/material';
import { LactateFormValues } from '../../formModel';

const FIELDS: { path: `meta.${keyof LactateFormValues['meta']}`; label: string; type?: string }[] = [
  { path: 'meta.date', label: 'Date', type: 'date' },
  { path: 'meta.age', label: 'Age' },
  { path: 'meta.height', label: 'Height' },
  { path: 'meta.weight', label: 'Weight' },
  { path: 'meta.location', label: 'Location' },
  { path: 'meta.lab', label: 'Lab' },
];

export const MetaSection: React.FC<{ control: Control<LactateFormValues> }> = ({ control }) => (
  <>
    <Typography variant="h6" sx={{ mb: 2 }}>
      Athlete & test details
    </Typography>
    <Grid container spacing={2}>
      {FIELDS.map((f) => (
        <Grid item xs={12} sm={6} md={4} key={f.path}>
          <Controller
            name={f.path}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label={f.label}
                type={f.type ?? 'text'}
                fullWidth
                size="small"
                InputLabelProps={f.type === 'date' ? { shrink: true } : undefined}
              />
            )}
          />
        </Grid>
      ))}
    </Grid>
  </>
);
